import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ImageLargeIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue433'}</MuiIcon>
    );
}
